<template>
    <div>
        <div>
            <div class="text-center" v-if="loading">
                <v-progress-circular indeterminate color="primary" :size="70"></v-progress-circular>
            </div>
            <v-row v-for="(period, index) in prestationReservationPeriods" :key="index" cols="12" md="4">
                <PrestationReservationPeriod :period="period" v-on:refreshList="fetchAll" />
            </v-row>
        </div>

        <v-form v-model="valid" class="pb-3 px-2 block-add-reserv-plan">
            <v-container>
                <v-row class="mt-4">
                    <!-- Start Time -->
                    <v-col cols="12" md="5" class="form_label_plan">
                        <v-text-field
                            v-model="form.start"
                            :label="$t('planningModal.startTime') + ' *'"
                            type="time"
                            :rules="[requiredRule, startEndRule]"
                            required
                            append-icon="mdi-clock-outline"
                        ></v-text-field>
                    </v-col>

                    <!-- End Time -->
                    <v-col cols="12" md="5" class="form_label_plan">
                        <v-text-field
                            v-model="form.end"
                            :label="$t('planningModal.endTime') + ' *'"
                            type="time"
                            :rules="[requiredRule, endAfterStartRule]"
                            required
                            append-icon="mdi-clock-outline"
                        ></v-text-field>
                    </v-col>

                    <!-- Active Checkbox -->
                    <v-col cols="12" md="2" class="pt-2 form_label_plan d-flex m-auto check-reserv-plan">
                        <v-checkbox v-model="form.active" :label="$t('common.enabled')" class="mt-lg-4 mt-md-0 pe-6"></v-checkbox>
                    </v-col>

                    <!-- Submit Button -->
                    <v-col cols="12" md="12" class="d-flex justify-content-center align-items-center">
                        <v-btn
                            class="btn-reserv-plan"
                            color="primary"
                            @click="addPeriod"
                            :disabled="!valid || addLoading"
                            :loading="addLoading"
                            >{{ $t('common.add') }}</v-btn
                        >
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-alert
                        v-if="log.show"
                        :class="{
                            'alert-msg': true,
                            [log.type]: !!log.type, // ajoute la classe log.type si log.type est défini
                        }"
                        dismissible
                    >
                        {{ log.message }}
                    </v-alert>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import ApiManager from '../Calendar/_core/ApiManager.js'
import PrestationReservationPeriod from './PrestationReservationPeriod.vue'
export default {
    name: 'PrestationReservation',
    props: {
        prestationId: {
            required: true,
        },
    },
    components: {
        PrestationReservationPeriod,
    },
    data() {
        return {
            prestationReservationPeriods: null,
            loading: false,
            addLoading: false,
            valid: false,
            form: {
                start: '',
                end: '',
                active: true,
            },
            log: {
                message: '',
                type: '',
                show: false,
            },
        }
    },

    components: {},

    methods: {
        async addPeriod() {
            this.addLoading = true
            try {
                const res = await ApiManager.createReservationPeriod(this.prestationId, this.form)
                this.fetchAll()
                this.resetForm()
                this.showSuccessMsg(this.$t('planningModal.periodAddSuccess'))
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.addLoading = false
            } finally {
                this.addLoading = false
                setTimeout(() => {
                    this.hideLogMsg()
                }, 10000)
            }
        },
        showErrorMsg(Msg) {
            this.log.message = Msg
            this.log.type = 'error'
            this.log.show = true
        },
        showSuccessMsg(Msg) {
            this.log.message = Msg
            this.log.type = 'success'
            this.log.show = true
        },
        hideLogMsg() {
            this.log.show = false
        },
        async fetchAll() {
            // Fetch
            this.loading = true
            try {
                this.prestationReservationPeriods = await ApiManager.getAllReservationPeriods(this.prestationId)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.loading = false
            } finally {
                this.loading = false
            }
            console.log('created  prestationReservationPeriods', this.prestationReservationPeriods)
        },
        resetForm() {
            // Remet chaque champ du formulaire à sa valeur initiale
            this.form = {
                start: '',
                end: '',
                active: false,
            }
            // Remet l'état de validation du formulaire à false
            // this.$refs.form.resetValidation()
        },
        validateStartEnd(value) {
            // Custom validation logic for start time
            console.log('validateStartEnd', this.form.end && value < this.form.end)
            return !this.form.end || (this.form.end && value < this.form.end) || this.$t('planningModal.errorTimeRange')
        },
        validateEndAfterStart(value) {
            // Custom validation logic for end time after start time
            return (this.form.start && value > this.form.start) || this.$t('planningModal.errorTimeRange')
        },
    },
    watch: {
        'form.start': function (newVal) {
            this.validateStartEnd(newVal)
            this.validateEndAfterStart(this.form.end)
        },
        'form.end': function (newVal) {
            this.validateEndAfterStart(newVal)
        },
    },

    created() {
        this.fetchAll()
    },
    computed: {
        requiredRule() {
            return (v) => !!v || this.$t('planningModal.requiredField')
        },
        startEndRule() {
            return (v) => this.validateStartEnd(v)
        },
        endAfterStartRule() {
            return (v) => this.validateEndAfterStart(v)
        },
    },
}
</script>
<style scoped lang="css">
.alert-msg {
    text-align: left;
}
.success {
    color: #021832 !important;
    background: linear-gradient(90deg, rgba(227, 248, 235, 1) 0%, rgba(238, 249, 243, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #01e17b !important;
    border: none;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    line-height: 385px;
    max-width: 38484px !important;
    z-index: 1;
    font-size: 15px;
}
.error {
    color: #021832 !important;
    background: linear-gradient(90deg, rgba(249, 233, 233, 1) 0%, rgba(249, 235, 236, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #de2c2c;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    line-height: 38px;
    max-width: 385px !important;
    z-index: 1;
    right: 15px !important;
}
</style>
